import React from 'react';

export default function Alert() {
  return (
    <div className='alert'>
      <h1>Board Meeting</h1>
      <p>Jul 24th at 6:00 PM</p>
      <h5>You have been invited to attend a<br /> meeting with the board of directors</h5>
    </div>
  );
}
